import { graphql } from "../generated/gql";

export const CreateEvaluation = graphql(`
  mutation CreateEvaluation($input: CreateEvaluationInput!) {
    createEvaluation(input: $input) {
      __typename

      ... on GenericException {
        ...BaseException
      }

      ... on ResourceNotFoundException {
        ...BaseException
      }

      ... on UserInputException {
        ...UserInputException
      }

      ... on Evaluation {
        ID
        scoreCardId
        scoreCardDescription
        scoreCardName
        scoreCardLanguage
        feedback
        revieweeUserId
        reviewerUserId
        callId
        categories {
          ID
          scoreCardCategoryId
          categoryOrder
          categoryName
          questions {
            ... on BinaryEvaluationQuestion {
              ID
              questionOrder
              questionText
              questionAiEnabled
              questionPossibleAnswers {
                binaryValue
                answerGuide
                points
              }
              scoreCardQuestionId
              feedback
              binaryAnswer
              score {
                scorePoints
                totalPoints
                normalizedScore
              }
            }
            ... on RatingEvaluationQuestion {
              ID
              feedback
              ratingAnswer
              score {
                scorePoints
                totalPoints
                normalizedScore
              }
              questionPossibleAnswers {
                ratingValue
                answerGuide
                points
              }
            }
          }
        }
        score {
          scorePoints
          totalPoints
          normalizedScore
        }
        createdBy
        createdAt
        updatedBy
        updatedAt
      }
    }
  }
`);
